import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../App";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

const LOGO_URL = "/brand/colacicco-logo-nero.png";

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [loginMethod, setLoginMethod] = useState("email");
  const [formData, setFormData] = useState({
    email: "",
    phone: "",
    password: ""
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const credentials = {
        password: formData.password,
        ...(loginMethod === "email" ? { email: formData.email } : { phone: formData.phone })
      };
      
      await login(credentials);
      toast.success("Accesso effettuato!");
      navigate("/");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Errore durante l'accesso");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center p-6">
      {/* Logo */}
      <div className="mb-10">
        <img src={LOGO_URL} alt="Colacicco Legno" className="h-20 w-auto" />
      </div>

      {/* Form */}
      <div className="w-full max-w-sm space-y-6">
        <div className="text-center space-y-2">
          <h1 className="text-2xl font-light text-white tracking-wide">Bentornato</h1>
          <p className="text-sm text-white/60">Accedi al tuo account</p>
        </div>

        {/* Login Method Toggle */}
        <div className="flex rounded-full bg-zinc-900 p-1">
          <button
            type="button"
            onClick={() => setLoginMethod("email")}
            className={`flex-1 py-2 text-sm rounded-full transition-all ${
              loginMethod === "email"
                ? "bg-emerald-500 text-black font-medium"
                : "text-white/60 hover:text-white"
            }`}
            data-testid="login-method-email"
          >
            Email
          </button>
          <button
            type="button"
            onClick={() => setLoginMethod("phone")}
            className={`flex-1 py-2 text-sm rounded-full transition-all ${
              loginMethod === "phone"
                ? "bg-emerald-500 text-black font-medium"
                : "text-white/60 hover:text-white"
            }`}
            data-testid="login-method-phone"
          >
            Telefono
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {loginMethod === "email" ? (
            <div className="space-y-2">
              <Label htmlFor="email" className="text-white/70 text-sm">Email</Label>
              <Input
                id="email"
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                placeholder="tuaemail@esempio.com"
                className="bg-zinc-900 border-zinc-800 text-white h-12 focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500"
                required
                data-testid="login-email-input"
              />
            </div>
          ) : (
            <div className="space-y-2">
              <Label htmlFor="phone" className="text-white/70 text-sm">Numero di telefono</Label>
              <Input
                id="phone"
                type="tel"
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                placeholder="+39 123 456 7890"
                className="bg-zinc-900 border-zinc-800 text-white h-12 focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500"
                required
                data-testid="login-phone-input"
              />
            </div>
          )}

          <div className="space-y-2">
            <Label htmlFor="password" className="text-white/70 text-sm">Password</Label>
            <Input
              id="password"
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              placeholder="••••••••"
              className="bg-zinc-900 border-zinc-800 text-white h-12 focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500"
              required
              data-testid="login-password-input"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full h-12 bg-white hover:bg-white/90 text-black font-normal rounded-full transition-all"
            data-testid="login-submit-btn"
          >
            {loading ? "Accesso in corso..." : "Accedi"}
          </Button>
        </form>

        <div className="text-center">
          <p className="text-sm text-white/60">
            Non hai ancora un account?{" "}
            <Link to="/register" className="text-emerald-500 hover:text-emerald-400 font-medium">
              Registrati
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
